import POSCreditNoteReference from './POSCreditNoteReference';

const POSCreditNoteInfo = () => {
  return (
    <div
      className="
        rounded-2xl

        border
        border-stroke

        bg-white

        p-4

        shadow-sm

        dark:border-strokedark
        dark:bg-boxdark
      "
    >
      {/* ===================================================== */}
      {/* 🔹 Header */}
      {/* ===================================================== */}
      <div
        className="
          mb-4
          flex
          items-start
          gap-3
        "
      >
        {/* 🔹 Icon */}
        <div
          className="
            flex
            h-10
            w-10
            shrink-0
            items-center
            justify-center

            rounded-xl

            bg-primary/10

            text-primary
          "
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
            />
          </svg>
        </div>

        {/* 🔹 Text */}
        <div className="min-w-0">
          <h3
            className="
              text-sm
              font-semibold
              text-slate-800

              dark:text-white
            "
          >
            Documento de referencia
          </h3>

          <p
            className="
              mt-1
              text-xs
              leading-relaxed
              text-slate-500

              dark:text-slate-400
            "
          >
            Selecciona la venta original
            relacionada con esta nota
            de crédito.
          </p>
        </div>
      </div>

      {/* ===================================================== */}
      {/* 🔹 Content */}
      {/* ===================================================== */}
      <POSCreditNoteReference />
    </div>
  );
};

export default POSCreditNoteInfo;